import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_GET_PHARMACY_DASHBOARD_METRICS } from "../../action-types/actions";

import i18n from "../../i18n";
export const getPharmacyDashboardMetrics = createAsyncThunk(
  ACTIONS_GET_PHARMACY_DASHBOARD_METRICS.get_pharmacy_dashboard_metrics,
  async (_, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getPharmacyDashboardMetrics}`,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        return response.data;
      } else {
        toast.error(
          response?.data?.message ||
            i18n.t("pharmacy.toast.failedToFetchPharmacyDashboardMetrics"),
        );
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("pharmacy.toast.errorFetchingPharmacyDashboardMetrics");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
